/**
 * @param {array} obj_errors
 * @returns {boolean}
 */
export var no_errors = function no_errors(obj_errors) {
  var error_count = 0;
  if (obj_errors) {
    Object.keys(obj_errors).map(function (key) {
      if (obj_errors[key]) {
        error_count += obj_errors[key].length;
      }
    });
  }
  return error_count === 0;
};
export var validate_field = function validate_field(component, value) {
  var errors = [];
  var props = component.props;

  /*if (props.required) {
   if (!value || value.trim().length === 0) {
   errors.push("This field is required")
   }
   }*/

  if (props.validations && props.validations.length > 0) {
    props.validations.map(function (validation) {
      if (validation === 'email') {
        if (value && value.length > 0) {
          if (!value.match(/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([0-9A-Za-z]{2,15})$/)) {
            errors.push("Invalid email format");
          }
        }
      }
      if (validation === 'required') {
        if ((value === null || value === void 0 ? void 0 : value.length) <= 0) {
          errors.push("This field is required.");
        }
      }
      if (validation.match(/^at_least=[0-9]+$/)) {
        var req_length = parseInt(validation.split("=")[1]);
        if (value) {
          if (Array.isArray(value)) {
            if (value.length < req_length) {
              errors.push("At least " + req_length + " record" + (req_length > 1 ? 's' : '') + ' is required for this field');
            }
          }
        } else {
          errors.push("This field is required.");
        }
      }
    });
  }

  // console.log(errors);

  return errors;
};
export var form_validator = {
  validate: function validate(validations, value) {
    var errors = [];
    var isStringish = typeof value === 'string' || typeof value === 'number';
    if (validations && Array.isArray(validations) && validations.length > 0) {
      validations.forEach(function (validation, idx) {
        if (validation.match(/^at_least=[0-9]+$/)) {
          var req_length = parseInt(validation.split("=")[1]);
          if (value) {
            if (Array.isArray(value)) {
              if (value.length < req_length) {
                errors.push("At least " + req_length + " record" + (req_length > 1 ? 's' : '') + ' is required for this field');
              }
            }
          } else {
            errors.push("This field is required.");
          }
        }
        if (validation === 'required') {
          if (value === void 0 || value === null || (value === null || value === void 0 ? void 0 : value.length) <= 0) {
            errors.push("This field is required.");
          }
        }
        if (isStringish) {
          var strValue = value.toString();
          if (validation === 'email') {
            if (strValue.length > 0) {
              if (!strValue.match(/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([0-9A-Za-z]{2,15})$/)) {
                errors.push("Invalid email format");
              }
            }
          }
          if (validation.match(/^min_len=[0-9]+$/)) {
            var _req_length = parseInt(validation.split("=")[1]);
            if (strValue.trim().length > 0) {
              if (strValue.length < _req_length) {
                errors.push("Value should at least be " + _req_length + " in length.");
              }
            }
          }
          if (validation.match(/^max_len=[0-9]+$/)) {
            var len = parseInt(validation.split("=")[1]);
            if (strValue.trim().length > 0) {
              if (strValue.length > len) {
                errors.push("Value should not exceed " + len + " characters in length.");
              }
            }
          }
          if (validation.match(/alpha_/)) {
            if (strValue.trim().length > 0) {
              if (!strValue.match(/^[a-zA-Z]+([a-zA-Z_]+)?$/)) {
                errors.push('This field only accepts letters and underscore/s. Underscores cannot be found at the start of the value.');
              }
            }
          }
          if (validation.match(/alphanum_/)) {
            if (strValue.trim().length > 0) {
              if (!strValue.match(/^[a-zA-Z]+([a-zA-Z0-9_]+)?$/)) {
                errors.push('This field only accepts letters, numbers, and underscore/s. Underscores cannot be found at the start.');
              }
            }
          }
          if (validation.match(/alphanum-/)) {
            if (strValue.trim().length > 0) {
              if (!strValue.match(/^[a-zA-Z0-9\-]+$/)) {
                errors.push('This field only accepts letters, numbers, and dashes.');
              }
            }
          }
          if (validation.match(/number/)) {
            if (strValue.trim().length > 0) {
              if (!strValue.trim().match(/^(-)?([0-9]+)?$/)) {
                errors.push("This field only accepts numbers.");
              }
            }
          }
          if (validation.match(/letter/)) {
            if (strValue.trim().length > 0) {
              if (!strValue.trim().match(/^[A-Za-z]+$/)) {
                errors.push("This field only accepts letters.");
              }
            }
          }
          if (validation.match(/decimal/)) {
            if (strValue.trim().length > 0) {
              if (!strValue.trim().match(/^(-)?[0-9]+(\.[0-9]+)?$/)) {
                errors.push("This field only accepts number with decimal places.");
              }
            }
          }
          if (validation.match(/no_trailing_dash/)) {
            if (strValue.trim().length > 0) {
              var finalValue = strValue.trim();
              if (finalValue.match(/^-+/) || finalValue.match(/-+$/)) {
                errors.push("This field can't have leading/trailing dashes.");
              }
            }
          }
          if (validation === "url") {
            // match a URL format
          }
        }
      });
    }
    return errors;
  }
};